import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import InterestListLayer from "../components/InterestListLayer";

const InterestListPage = () => {
  return (
    <MasterLayout>
      <InterestListLayer />
    </MasterLayout>
  );
};

export default InterestListPage;
